import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"

//pass new generated access token here
const token = accessToken

//apply base url for axios
const API_URL = ""

const axiosApi = axios.create({
  baseURL: API_URL,
})

axiosApi.interceptors.request.use(config => {
  const activeToken = localStorage.getItem("token");
  if (activeToken) {
    config.headers["Authorization"] = `Bearer ${activeToken}`;
  }
  return config;
});

axiosApi.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.data?.code === "MUST_CHANGE_PASSWORD") {
      localStorage.setItem("mustChangePassword", "true");
      if (typeof window !== "undefined" && window.location.pathname !== "/change-password") {
        window.location.replace("/change-password");
      }
    }
    return Promise.reject(error);
  }
)

export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
